import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CubeFrontLeftIcon = function CubeFrontLeftIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CubeFrontLeftIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsxs("g", {
      fill: "currentColor",
      clipPath: "url(#clip0_1217_61337)",
      children: [jsx("path", {
        d: "M2.002 11V5l5 3L7 14z"
      }), jsx("path", {
        fillRule: "evenodd",
        d: "M6.624.284a1.89 1.89 0 0 1 1.954 0l4.666 2.801c.295.179.536.434.703.736s.253.643.253.988v5.602c0 .345-.087.686-.253.988a1.97 1.97 0 0 1-.703.736l-.002.001-4.664 2.8h-.002a1.88 1.88 0 0 1-1.954 0l-4.664-2.8-.002-.001a1.97 1.97 0 0 1-.703-.736A2.06 2.06 0 0 1 1 10.411V4.81c0-.345.087-.686.253-.988.167-.303.408-.557.703-.736l.002-.001 4.664-2.8zM8.2 1.457V6.6l4.484-2.446-.06-.041h-.002zM13 5.348v4.524L8.853 7.61zM7 6.599 2.516 4.153l.06-.041h.002L7 1.456zM2.2 5.348 7 7.966v5.797l-4.422-2.654h-.001a.77.77 0 0 1-.272-.288.86.86 0 0 1-.105-.41zm6 8.415V8.62l4.484 2.446-.062.042z",
        clipRule: "evenodd",
        opacity: ".3"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_1217_61337",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

export { CubeFrontLeftIcon };
